import PropTypes from "prop-types";

export const FormWrapper = ({ children }) => (
  <div className="form-wrapper !mt-6">{children}</div>
);

FormWrapper.propTypes = {
  children: PropTypes.any.isRequired,
};
